import useRequestTable from 'app/hooks/useRequestTable'

import {
    RequestKeys,
} from 'app/hooks/useRequest'
import requests from 'app/requests/Location.requests'

import {
    LocationAreas,
} from '../LocationAreas.types'

export default (locationId: number) => {
    return useRequestTable<LocationAreas>({
        key: RequestKeys.getLocationAreaDetailsByLocationId,
        params: {
            id: locationId,
        },
        config: requests.getAreasByLocation,
        keepPreviousData: true,
    })
}
